<template>
  <!-- <el-scrollbar style="height: 100%;" ref="scrollbar"> -->
    <div
      id="app"
      :class="{
        auto:
          path == '/cn/download/miniRTK' ||
          path == '/cn/download/DasInsightAPP',
        nohf: !withHF
      }"
    >
      <appHeader
        v-if="withHF"
        v-show="hf"
        :class="{ topheader: path == '/' }"
      ></appHeader>
      <!-- class="content" -->
      <router-view
        :class="{
          top:
            path == '/' ||
            path == '/cn/download/miniRTK' ||
            path == '/cn/download/DasInsightAPP'
        }"
      ></router-view>
      <appFooter v-if="withHF" v-show="show"></appFooter>
    </div>
  <!-- </el-scrollbar> -->
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      path: this.$router.currentRoute.path,
      show: false,
      hf: false,
      withHF: true
    };
  },
  mounted() {
    setTimeout(() => {
      if (this.hf) this.show = true;
    }, 1000);
  },
  watch: {
    $route: function() {
      this.path = this.$router.currentRoute.path;
      if (
        this.path != "/cn/download/miniRTK" &&
        this.path != "/cn/download/DasInsightAPP"
      )
        this.hf = true;

      console.log("router", this.path);
      if (this.path == "/cn/DV-publicity") this.withHF = false;
      else this.withHF = true;
    }
  }
};
</script>

<style>
.warning {
  color: #f59a23;
}

.error {
  color: #f56c6c;
}

.success {
  color: #67c23a;
}

.blue {
  color: #409eff;
}

.gray {
  color: #b3b3b3;
}

@font-face {
  font-family: font1;
  src: url("/static/font/1.otf");
}

@font-face {
  font-family: font2;
  /* src: url("/static/font/PingFang-Medium.ttf"); */
  src: url("/static/font/PingFang-Medium.woff");
  font-weight: 500;
}

@font-face {
  font-family: font2;
  /* src: url("/static/font/PingFang-Regular.ttf"); */
  src: url("/static/font/PingFang-Regular.woff");
  font-weight: 400;
}

@font-face {
  font-family: font2;
  /* src: url("/static/font/PingFang-Semibold.ttf"); */
  src: url("/static/font/PingFang-Semibold.woff");
  font-weight: 600;
}

body {
  /* height: 100%; */
  /* width: 100%; */
}

#app {
  /*font-family: font1 !important;*/
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /* font-family: Source Han Sans CN, PingFang SC !important; */
  font-family: "HarmonyOS Sans SC";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #212121;
  letter-spacing: 1px;
  font-size: 14px;
  height: 100%;
  background-color: #f5f5f7;
  min-width: 1200px;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
}

#app.nohf {
  min-width: auto;
}

#app.auto,
#app.auto .content {
  min-width: auto;
}

input,
textarea,
select,
button,
section,
.el-popper,
.el-dialog,
.el-message-box,
.el-loading-spinner,
#driver-popover-item,
.driver-popover-title,
.driver-popover-description {
  /* font-family: Source Han Sans CN, PingFang SC !important; */
  font-family: "Microsoft YaHei", "PingFang SC", Arial, "Helvetica Neue",
    Helvetica, "Hiragino Sans GB", "微软雅黑", sans-serif;
}

.content {
  height: 100%;
  z-index: 0;
  padding-top: 70px;
  min-width: 1200px;
}

.content.top {
  padding-top: 0px;
}

.input .el-button {
  padding: 7px 14px;
}

.dialog.top .el-dialog {
  margin-top: 10px !important;
  margin-bottom: 0 !important;
  position: relative;
  left: -10px;
}

.dialog.top .el-dialog__body {
  padding: 0;
}

.dialogsm .el-dialog__body {
  padding: 0 !important;
}

.dialogsm.high .el-dialog {
  margin-top: 5vh !important;
}

.dialogsm.rounded .el-dialog {
  border-radius: 16px;
  margin-top: 35vh !important;
}

.el-scrollbar__wrap {
  overflow-x: hidden !important;
  padding-bottom: 17px;
}

.blue {
  color: rgba(64, 158, 255, 1);
}

.el-tabs__item {
  height: 32px !important;
  line-height: 32px !important;
}

.el-progress-bar__outer,
.el-progress-bar__inner {
  border-radius: 4px !important;
}

.el-button--primary {
  background: linear-gradient(0deg, #1472e2 0%, #2d8ef7 100%);
  border-radius: 4px;
  border: none;
  padding: 7px 0;
  text-align: center;
  width: 90px;
  font-size: 14px;
  letter-spacing: 2px;
}

.el-button--primary:focus,
.el-button--primary:hover {
  background: linear-gradient(
    0deg,
    rgba(20, 113, 226, 0.8),
    rgba(45, 142, 247, 0.8)
  );
}

.is-disabled.el-button--primary:focus,
.is-disabled.el-button--primary:hover {
  background: #a0cfff !important;
}

.el-popover {
  min-width: 110px;
}

.smpopover.el-popover {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue